export default __webpack_public_path__ + "41071a9e49847b7c7f3b45eac39afd55.svg";